import React, { useState } from "react";

const RecordPaymentModal = ({
  isOpen,
  onClose,
  onSubmit,
  balanceDue = 0,
  isLoading = false,
}) => {
  const [amount, setAmount] = useState("");
  const [method, setMethod] = useState("cash");
  const [note, setNote] = useState("");
  const [referenceNumber, setReferenceNumber] = useState("");
  const [receiptFile, setReceiptFile] = useState(null);

  const resetFields = () => {
    setAmount("");
    setMethod("cash");
    setNote("");
    setReferenceNumber("");
    setReceiptFile(null);
  };

  const handleClose = () => {
    resetFields();
    onClose();
  };

  const handleSubmit = () => {
    onSubmit({ amount, method, note, referenceNumber, receiptFile }, resetFields);
  };

  return (
    <div
      className={`modal fade ${isOpen ? "show d-block" : ""}`}
      tabIndex="-1"
      role="dialog"
      style={{ backgroundColor: isOpen ? "rgba(0,0,0,0.5)" : "transparent" }}
    >
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content shadow-lg border-0">
          <div className="modal-header border-0 pb-0">
            <h5 className="modal-title fw-bold fs-4">Record Payment</h5>
            <button
              type="button"
              className="btn-close"
              onClick={handleClose}
              aria-label="Close"
              disabled={isLoading}
            ></button>
          </div>
          <div className="modal-body py-4">
            <p className="fs-6 text-gray-700">
              Balance due: <strong>${Number(balanceDue).toFixed(2)}</strong>
            </p>
            <div className="mb-3">
              <div className="d-flex justify-content-between align-items-center">
                <label className="form-label fw-bold">Amount Received</label>
                {Number(balanceDue) > 0 && (
                  <button
                    type="button"
                    className="btn btn-link btn-sm p-0 mb-2"
                    onClick={() => setAmount(Number(balanceDue).toFixed(2))}
                  >
                    Pay full balance
                  </button>
                )}
              </div>
              <input
                type="number"
                step="any"
                min="0"
                className="form-control"
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
              />
            </div>
            <div className="mb-3">
              <label className="form-label fw-bold">Method</label>
              <select
                className="form-select"
                value={method}
                onChange={(e) => setMethod(e.target.value)}
              >
                <option value="cash">Cash</option>
                <option value="bank-transfer">Bank Transfer</option>
                <option value="online">Online (Debit/Credit Card)</option>
              </select>
            </div>
            <div className="mb-3">
              <label className="form-label fw-bold">
                Receipt / Ref # (optional)
              </label>
              <input
                type="text"
                className="form-control"
                value={referenceNumber}
                onChange={(e) => setReferenceNumber(e.target.value)}
              />
            </div>
            <div className="mb-3">
              <label className="form-label fw-bold">Note (optional)</label>
              <input
                type="text"
                className="form-control"
                value={note}
                onChange={(e) => setNote(e.target.value)}
              />
            </div>
            <div className="mb-3">
              <label className="form-label fw-bold">
                Upload Receipt (optional)
              </label>
              <input
                type="file"
                accept="image/*,application/pdf"
                className="form-control"
                onChange={(e) => setReceiptFile(e.target.files?.[0] || null)}
              />
              {receiptFile && (
                <div className="form-text">{receiptFile.name}</div>
              )}
            </div>
          </div>
          <div className="modal-footer border-0 pt-0">
            <button
              type="button"
              className="btn btn-light-secondary fw-bold"
              onClick={handleClose}
              disabled={isLoading}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-primary fw-bold"
              onClick={handleSubmit}
              disabled={isLoading || !amount || Number(amount) <= 0}
            >
              {isLoading ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm me-2"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  Saving...
                </>
              ) : (
                "Save Payment"
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RecordPaymentModal;
